import { render, staticRenderFns } from "./NewUpload.vue?vue&type=template&id=ba78bf18&"
import script from "./NewUpload.vue?vue&type=script&lang=js&"
export * from "./NewUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports